import { publish } from "@jutro/events";
export function trackMethod(callback, topic, payload) {
  return function () {
    callback && callback.apply(void 0, arguments), publish(topic, payload);
  };
}